import script from "./WCCarouselModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCCarouselModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCCarouselModern.vue?vue&type=style&index=0&id=e14101ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e14101ca"]])

export default __exports__